<script lang="ts">
  import {
    Collapsible,
    type CollapsibleContentProps,
  } from "#lib/internal/components/collapsible/index"
  import { cn } from "#lib/utils"
  import type { Snippet } from "svelte"

  type Props = CollapsibleContentProps & {
    children?: Snippet
  }

  let {
    class: className = undefined,
    transition = true,
    children,
    ...restProps
  }: Props = $props()
</script>

<Collapsible.Content
  class={cn("overflow-hidden text-sm", className)}
  {...restProps}
  {transition}
>
  {@render children?.()}
</Collapsible.Content>
